export default {"src":"/_next/static/media/CPF.107d0303.svg","height":340,"width":512,"blurWidth":0,"blurHeight":0};